import { apiClient } from './apiClient';

export const createCoupon = async (payload) => {
  return await apiClient('/admin/coupons', {
    method: 'POST',
    body: JSON.stringify(payload),
  }, true);
};

export const getCoupons = async (params = {}) => {
  const { page = 0, size = 20, search = '', couponType = '', isActive } = params;
  const queryParams = new URLSearchParams();
  queryParams.append('page', page);
  queryParams.append('size', size);
  if (search) queryParams.append('search', search);
  if (couponType) queryParams.append('couponType', couponType);
  if (isActive !== undefined && isActive !== '') queryParams.append('isActive', isActive);
  return await apiClient(`/admin/coupons?${queryParams.toString()}`, { method: 'GET' }, true);
};

export const getCouponDetail = async (couponId) => {
  return await apiClient(`/admin/coupons/${couponId}`, { method: 'GET' }, true);
};

export const toggleCouponActive = async (couponId, isActive) => {
  return await apiClient(`/admin/coupons/${couponId}/active`, {
    method: 'PATCH',
    body: JSON.stringify({ isActive }),
  }, true);
};

export const deleteCoupon = async (couponId) => {
  return await apiClient(`/admin/coupons/${couponId}`, {
    method: 'DELETE',
  }, true);
};

export const getCouponTypeOptions = () => [
  { value: 'WELCOME', label: '웰컴' },
  { value: 'EVENT', label: '이벤트' },
  { value: 'PROMOTION', label: '프로모션' },
  { value: 'BIRTHDAY', label: '생일' },
];

export const getDiscountTypeOptions = () => [
  { value: 'AMOUNT', label: '정액 할인' },
  { value: 'PERCENT', label: '정률 할인' },
];

export const getTargetTypeOptions = () => [
  { value: 'ALL', label: '전체 고객' },
  { value: 'SPECIFIC_CUSTOMERS', label: '특정 고객' },
  { value: 'SPECIFIC_STORES', label: '특정 매장' },
];

export const getCouponTypeLabel = (type) => {
  const map = { WELCOME: '웰컴', EVENT: '이벤트', PROMOTION: '프로모션', BIRTHDAY: '생일' };
  return map[type] || type;
};

export const getDiscountTypeLabel = (type) => {
  const map = { AMOUNT: '금액형', PERCENT: '정률형' };
  return map[type] || type;
};

export const getTargetTypeLabel = (type) => {
  const map = { ALL: '전체 고객', SPECIFIC_CUSTOMERS: '특정 고객', SPECIFIC_STORES: '특정 매장' };
  return map[type] || type;
};